import type { FaireProductEntity } from "../../entity_types/product";

export const p_59a373mwjb: FaireProductEntity = {
  token: "p_59a373mwjb",
  type: "product",
  name: "Sovereign Silver - Immume Support Mist Spray - 1 Each-2 Fz",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/5bc612797efb147202234ef0824ec75420fe1320a1b3ec2f11accd20aa904d39.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9eee41f8c759db6e9caaa1aff5a0350a79fbeebbeae139b18ffc422f2bb99b5b.jpeg",
  ],
  priceDollars: 17.15,
  description:
    "\n\nDiscover the benefits of a fine mist spray designed to support your body's defenses with bio-active silver hydrosol. This dietary supplement combines silver with pharmaceutical grade purified water to aid in immune-building and provides long term immune support. Perfect for those mindful of their dietary choices, this supplement is gluten-free, non-GMO, and vegan, ensuring it suits a variety of lifestyles.\n\n * Size: 2 fl. oz. for easy portability \n * Origin: Made in the USA, Florida \n * Free from gluten, GMOs, wheat, and yeast \n * Convenient spray application for quick use \n * Packaged as a single easy-to-use unit \nSupport your immune system with a product that's crafted to fit seamlessly into your daily routine.\n",
  tags: [],
  msrpDollars: 34.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:57.251Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
